import React, {useState, useEffect} from 'react';
import {Table, Input, List, Button, Tabs, message} from 'antd';
import history from "../../../libs/history";
import styles from './layout.module.less'

import store from "./store";
import addressStore from "../info/address/store"
import {observer} from 'mobx-react';
import {toJS} from "mobx";

// the hook
import {useTranslation} from 'react-i18next';


export default observer(function () {
  const {t, i18n} = useTranslation()
  const {goods, orders, orderIndex, express, invoice} = store

  const [loading, setLoading] = useState(false)

  if (orderIndex === -1) {
    history.push('/user/order')
    return
  }

  useEffect(() => {
    let data = {
      type: orders[orderIndex]['type'],
      sn: orders[orderIndex]['sn'],
      product_id: goods['product_id']
    }
    store.getExpress(data).then()
  }, [])

  const columns = [
    {
      title: '',
      dataIndex: 'type',
      className: 'pl0',
      width: 35,
      fixed: true,
      render: val => <div
        className={[styles.badge, val * 1 !== 1 ? styles.badgeGhost : '', i18n.language === 'en' ? styles.autoWidth : ''].join(' ')}>
        {val * 1 === 1 ? t('购') : t('租')}
      </div>,
    },
    {
      title: t('品牌'),
      dataIndex: 'brand',
      align: 'center',
      fixed: true,
      width: 90,
    },
    {
      title: t('产品品名'),
      dataIndex: 'name',
      align: 'center',
      fixed: true,
      width: 130,
    },
    {
      title: t('货号'),
      dataIndex: 'factory_code',
      align: 'center',
      fixed: true,
      width: 90,
    },
    {
      title: t('规格'),
      dataIndex: 'formats',
      align: 'center',
      fixed: true,
      width: 50,
    },
    {
      title: t('单价'),
      dataIndex: 'price',
      fixed: true,
      align: 'center',
    },
    {
      title: t('租期'),
      dataIndex: 'duration',
      width: 50,
      fixed: true,
      align: 'center',
    },
    {
      title: t('合计'),
      dataIndex: 'number',
      align: 'center',
      fixed: true,
      render: (text, record, index) => text * record['price']
    },
    {
      title: t('数量'),
      dataIndex: 'number',
      width: 50,
      fixed: true,
      align: 'center',
    },
    {
      title: t('项目编号'),
      dataIndex: 'extra_sn',
      align: 'center',
      fixed: true,
    },
    {
      title: t('总计'),
      dataIndex: 'number',
      align: 'center',
      fixed: true,
      render: (text, record, index) => text * record['price']
    },
    {
      title: t('预计到货'),
      dataIndex: 'period',
      width: 70,
      fixed: true,
      align: 'center',
    },
  ]

  const data = orders[orderIndex]
  return (
    <React.Fragment>
      <div className={styles.cart}>

        <div className={styles.listTitle}>
          <span className={styles.title}>{t('查看物流')}</span>

          <a onClick={() => {
            history.push('/user/order')
          }}>&lt;{t('返回订单列表')}</a>
        </div>

        <div className="mainBox-">

          <div className="paramSelect">
            <div className="h1"/>
          </div>

          <div className={styles.innerTitle}>
            <div>{t('订单编号')}：{data.sn}</div>
            <div style={{flex: 1, marginLeft: "0.1979rem"}}>{t('报价单总金额')}： <b
              style={{color: '#cc0000'}}>￥{data['total_price'].toFixed(2)}</b></div>
            <div style={{marginRight: 38}}>{t('配送下单时间')}： 2020-10-09 11:00:00</div>
            <div>{t('报价时间')}： {data.created_at}</div>
          </div>
          <Table className={styles.table}
                 pagination={false}
                 rowKey={item => item.id + '-' + item.type}
                 dataSource={[goods]}
                 columns={columns}/>


          <div className="flex flex-start">
            <div className="paramSelect">
              <div className="h2">
                <span>{t('发票信息')}</span>
              </div>

              <div className="paramsList static1">
                <div className="item" style={{margin: 0, padding: 0, width: 'auto', minHeight: 'auto'}}>
                  <div className="param">
                    <div className="label" style={{fontWeight:400,opacity:0.8}}>{t('发票抬头')}：</div>
                    <div className="text">{invoice['title']}</div>
                  </div>
                  <div className="param">
                    <div className="label" style={{fontWeight:400,opacity:0.8}}>{t('纳税登记号')}：</div>
                    <div className="text">{invoice['tax_sn']}</div>
                  </div>
                </div>

              </div>
            </div>


          </div>

          <div className={styles.expressBox}>
            <div className={styles.h2}>
              <span>{t('收货信息')}</span>
            </div>

            <div className={styles.express}>
              {
                express.length && express.map((item, index) => {
                  return (
                    <div key={index} className={styles.expressItem}>
                      <div className={styles.location}>
                        <div>{t('联系人')}：{item['consign']} {item['phone']}</div>
                        <div>{t('地址')}：{item['province']}{item['city']}{item['area']} {item['details']}</div>
                      </div>
                      <div className={styles.expressGoods}>
                        <table>
                          <thead>
                          <tr>
                            <th style={{textAlign:"left",paddingLeft:"0.224rem"}}>{t('物流单号')}</th>
                            <th>{t('货号')}</th>
                            <th>{t('品牌')}</th>
                            <th>{t('产品名称')}</th>
                            <th>{t('规格')}</th>
                            <th>{t('数量')}</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td style={{textAlign:"left",paddingLeft:"0.224rem"}}>{item['express']?item['express']['no']:t('待发货')}</td>
                            <td>{goods['factory_code']}</td>
                            <td>{goods['brand']}</td>
                            <td>{goods['name']}</td>
                            <td>{goods['formats']}</td>
                            <td>{item['number']}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>

                      {
                        item['express'] ? (
                          <div className={styles.expressTimeLine}>
                            <div className={styles.tit}>
                              <span>{t('运单号码')}：{item['express']['no']}</span>
                              <span style={{marginLeft: '0.1563rem'}}>{t('物流公司')}：{item['express']['company']}</span>
                            </div>
                            <div className="flex flex-start">
                              <div>{t('物流信息')}：</div>
                              <div className={styles.p}>
                                {
                                  item['express'].detail && item['express'].detail.map((v, index) => {
                                    return (
                                      <p key={index}>{v.time} <span style={{marginLeft: '0.1563rem'}}>{v.context}</span></p>
                                    )
                                  })
                                }
                              </div>
                            </div>
                          </div>
                        ) : null
                      }

                    </div>
                  )
                })
              }
            </div>


          </div>

        </div>


      </div>

    </React.Fragment>
  )

})
